import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import UserSync from './UserSync';
import ClientData from './ClientData';
import PostHogSync from './PostHogSync';

const DataSync = (props) => {
  return (
    <>
      <UserSync />
      <ClientData />
      <PostHogSync />
    </>
  );
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(DataSync);
